import type { SlotData } from './types';

// This store is not redux and is mutable to not cause performance overhead on mousemove
interface SlotOpenerState {
  availableSlot: SlotData | null;
  allSlotsInContainer: SlotData[];
  shouldOpenSlot: boolean;
}

const store: SlotOpenerState = {
  availableSlot: null,
  allSlotsInContainer: [],
  shouldOpenSlot: false,
};

export const getAvailableSlot = () => store.availableSlot;
export const setAvailableSlot = (slot: SlotData) =>
  (store.availableSlot = slot);

export const getAllSlotsInContainer = () => store.allSlotsInContainer;
export const setAllSlotsInContainer = (slots: SlotData[]) =>
  (store.allSlotsInContainer = slots);

export const getShouldOpenSlot = () => store.shouldOpenSlot;
export const setShouldOpenSlot = (should: boolean) =>
  (store.shouldOpenSlot = should);
